/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";

/**
 *
 * @export
 * @interface Sqlite
 */
export interface Sqlite {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly file?: FileReadOnly;
  /**
   *
   */
  readonly revisionId?: number;
}

/**
 * Check if a given object implements the Sqlite interface.
 */
export function instanceOfSqlite(value: object): value is Sqlite {
  return true;
}

export function SqliteFromJSON(json: any): Sqlite {
  return SqliteFromJSONTyped(json, false);
}

export function SqliteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sqlite {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    revisionId: json["revision_id"] == null ? undefined : json["revision_id"],
  };
}

export function SqliteToJSON(json: any): Sqlite {
  return SqliteToJSONTyped(json, false);
}

export function SqliteToJSONTyped(
  value?: Omit<Sqlite, "id" | "file" | "revisionId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
